import Icon from "@Components/generic/icon";
import { IconDefinition, SizeProp } from "@fortawesome/fontawesome-svg-core";
import { Box } from "@mui/material";
import { ChallengeCardIconWrapper } from "../challenges/cards/styled-components";

interface IChallengeCardStatusIcon {
  icon: IconDefinition;
  color?: string;
  size?: number;
  iconSize?: SizeProp;
}

/**
 *
 * @param icon - FontAwesome icon definition
 * @param color - Optional hexadecimal color value
 * @param size - Icon wrapper size
 * @param iconSize - FontAwesome icon size
 *
 * @returns
 */
const CardStatusIcon = ({ icon, color = "#EEE", size = 56, iconSize = "xl" }: IChallengeCardStatusIcon) => {
  return (
    <Box
      sx={{
        borderRadius: 999,
        height: size,
        width: size,
        overflow: "hidden",
        position: "absolute",
        top: "50%",
        left: "50%",
        translate: "-50% -50%",
        backdropFilter: "blur(8px)",
        zIndex: 1,
      }}
    >
      <ChallengeCardIconWrapper>
        <Icon icon={icon} color={color} size={iconSize} />
      </ChallengeCardIconWrapper>
    </Box>
  );
};

export default CardStatusIcon;
